import { Modal, Spinner } from 'react-bootstrap';

const ClosingProgressPopup = ({ show, currentIssue, totalIssues, action }) => {
  return (
    <Modal
      show={show}
      onHide={() => {}}
      backdrop="static"
      keyboard={false}
      style={{ top: '150px' }}
    >
      <Modal.Header>
        <Modal.Title>{action.charAt(0).toUpperCase() + action.slice(1)} Issues ...</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center mb-3">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
        <div className="text-center">
          Closing issue {currentIssue} of {totalIssues}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ClosingProgressPopup;